import { PolicyTermSearchRequestQuery } from '@lio/api-types';

export const policyTermQueryKey = {
  search: ['policyTerm'] as const,
  searchWithParams: (policyId: string, params: PolicyTermSearchRequestQuery) =>
    [...policyTermQueryKey.search, policyId, params] as const,
};
